// Selectors
export const selectUserSelf = store => (store.session.user.self);
export const selectUserLoaded = store => (store.session.user.loaded);
export const selectUserInvites = store => (store.session.user.invites);
export const selectRoute = store => (store.routing.locationBeforeTransitions.pathname);



// WEBPACK FOOTER //
// ./mobile/shared/flows/session/selectors.js